import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import useStores from './stores/useStores';

const KeyboardShortcuts = ({ children }) => {
  const { buildingStore, uiStore } = useStores();
  const history = useHistory();

  const handleOnKeyDown = e => {
    const { pickedResults, resultMap } = buildingStore;
    if (e.ctrlKey && e.keyCode === 'P'.charCodeAt(0)) {
      e.preventDefault();
      if (uiStore.version === 'v2') {
        uiStore.setUIVersion('v1');
      } else {
        uiStore.setUIVersion('v2');
      }
    }

    if (history.location.pathname === '/search') {
      if (e.ctrlKey && e.keyCode === 'A'.charCodeAt(0)) {
        e.preventDefault();
        uiStore.setSearchPanelState('picker');
        if (resultMap.size === pickedResults.size) {
          buildingStore.clearPicked();
        } else {
          buildingStore.pickAllResults();
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleOnKeyDown);
    return () => {
      window.removeEventListener('keydown', handleOnKeyDown);
    };
  }, []);

  return (
    <div
      style={{ height: 'inherit' }}
      tabIndex="-1"
      role="complementary"
      // onKeyDown={handleOnKeyDown}
      onPaste={() => {
        /*

        return;
        if (!projectDetailStore.id) return;
        const paste = (event.clipboardData || window.clipboardData).getData(
          'text'
        );

        const data = paste
          .split(`\n`)
          .map(line => {
            return line
              .split(`\t`)
              .map(item => `"${item}"`)
              .join('\t');
          })
          .join(`\n`);
        console.log(data);

        const blob = new Blob([data], { type: 'text/plain' });
        projectDetailStore.setAcceptedFiles([blob]);
        event.preventDefault();
        */
      }}
    >
      {children}
    </div>
  );
};

export default observer(KeyboardShortcuts);
